module.exports = __webpack_public_path__ + "static/media/Bluelab Guardian Monitor Wi-Fi.43d7e407.webp";